export const MISSING_AUTH_TOKENS_MESSAGE = 'Missing access or refresh token'

export class MissingAuthTokensError extends Error {
  constructor() {
    super(MISSING_AUTH_TOKENS_MESSAGE)
    this.name = 'MissingAuthTokensError'
  }
}
